module.exports = __webpack_public_path__ + "img/ruan4.8cd21bdc.jpg";